<template>
    <k-page>
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container size="lg" class="pb-20 mt-10">
          <div class="mb-5" style="display: flex; justify-content: flex-end;">
                  <a-button type="primary" v-if="!$root.$data.investorProfile.vwoFeatures.goBackToReact.goBackToReactButtonHide" @click="this.$goBackToNewPlatform">Go back to new UI</a-button>
                </div>
            <account-statement-table
                :account-statement="accountStatement"
                @get-account-statement="getStatement"
                @download-statement="downloadStatement"
                @open-tranche="openTranche"
            />
        </k-container>
    </k-page>
</template>

<script>
    import ProfileHeader from '@investor/components/profile/ProfileHeader';
    import AccountStatementTable from '@product-common/components/investor/AccountStatementTable';

    export default {
        components: {
            ProfileHeader,
            AccountStatementTable
        },
        data() {
            return {
                accountStatement: {
                    openingBalance: 0,
                    closingBalance: 0,
                    result: {
                        items: [],
                        totalItems: 0
                    }
                }
            };
        },
        methods: {
            async getStatement(query) {
                let resp = await this.$post('account-statement', query);
                this.accountStatement = resp;
                this.accountStatement.result = {
                    totalItems: resp.totalTxs,
                    items: resp.txs
                };
            },
            async downloadStatement(query) {
                this.$startLoading();
                try {
                    const response = await this.$http.post('/api/investor/account-statement/download', query, { responseType: 'arraybuffer' });
                    let blob = new Blob([response.data], { type: response.headers['content-type'] });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = response.headers['k-filename'];
                    link.click();
                } finally {
                    this.$finishLoading();
                }
            },
            async openTranche(trancheUuid) {
                this.$router.push({name: 'tranche-invest', params: {trancheUuid: trancheUuid}});
            }
        },
    };
</script>


